import React from "react";
import { fileSystem } from 'fs';
import { path } from 'path';
import axios from "axios";

const validUrl = (url) => {
    var expression = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi;
    return expression.test(url);
}

const validTypeImage = (image) => {
    return /\.(jpe?g|png|gif|bmp)$/gi.test(image);
}

const base64ToNode = (buffer) => {
    return buffer.toString('base64');
}

const readFileAndConvert = (fileName) => {
    if (fileSystem.statSync(fileName).isFile()) {
        return base64ToNode(fileSystem.readFileSync(path.resolve(fileName)).toString('base64'));
    }
    return null;
}

const isImage = ( urlOrImage ) => {
    if (validTypeImage(urlOrImage)) {
        return Promise.resolve(readFileAndConvert(urlOrImage));
    } else {
        return Promise.reject('[*] An error occured: Invalid image [validTypeImage === false]');
    }
}
  
const imageToBase64 = (urlOrImage, options) => {
    if (validUrl(urlOrImage)) {
        return axios.get(urlOrImage, 
        { 
            responseType: 'arraybuffer', 
            transformRequest: (data, headers) => 
            {
                // prevent the header from being added by default
                delete headers.common['Authorization'];
                // some libraries might set it directly as well, e.g. nuxtjs/auth
                delete headers['Authorization'];
                return data;
            }
        })
        .then((response) => {
            let image = btoa(
            new Uint8Array(response.data)
                .reduce((data, byte) => data + String.fromCharCode(byte), '')
            );
            return `data:${response.headers['content-type'].toLowerCase()};base64,${image}`;
        });
        // const response = await fetch(urlOrImage, options);
        // const blob = await response.blob();
        // return new Promise((onSuccess, onError) => {
        //   try {
        //     const reader = new FileReader() ;
        //     reader.onload = function(){ onSuccess(this.result) } ;
        //     reader.readAsDataURL(blob) ;
        //   } catch(e) {
        //     onError(e);
        //   }
        // });
    } else {
        return isImage(urlOrImage);
    }
}

export default imageToBase64;